/*
 * File: common
 * File Created: 2021-05-12 3:57:17 pm
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-05-18 11:43:02 am
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

export default {
  state: {
    browserMeetingUrl: undefined
  },
  getters: {
    browserMeetingUrl(state) {
      return state.browserMeetingUrl
    }
  },
  mutations: {
    setBrowserMeetingUrl(state, url) {
      state.browserMeetingUrl = url
    }
  }
}
